<script setup lang="ts">
import { useAsyncData } from "#app";
import { repository } from "~/repository";
import { isArray } from "lodash-es";
import { getThumbnailImage } from "~/utils/common";
import SeasonsOrEpisodes from "~/components/Collections/SeasonsOrEpisodes.vue";
import { useCommonStore } from "~/stores/common/store";

const route = useRoute();
const commonStore = useCommonStore();

onMounted(() => {
  commonStore.fetchVideoProgress();
});

const { data: collectionData, pending } = await useAsyncData(
  async () => {
    const [listResponse] = await Promise.all([
      repository.common.fetchCollectionBySlug({
        slug: isArray(route.params.slug)
          ? route.params.slug[0]
          : route.params.slug,
      }),
      commonStore.fetchVideoProgress(),
    ]);
    return listResponse.data;
  },
  {
    lazy: true,
  },
);

useSeoMeta({
  title: () => `${collectionData.value?.title} | PokerGO`,
  description: () => collectionData.value?.description,

  ogTitle: () => collectionData.value?.title,
  ogDescription: () => collectionData.value?.description,
  ogImage: () =>
    getThumbnailImage([
      collectionData.value?.images || [],
      collectionData.value?.pre_air_images || [],
    ]),

  twitterTitle: () => collectionData.value?.title,
  twitterDescription: () => collectionData.value?.description,
  twitterImage: () =>
    getThumbnailImage([
      collectionData.value?.images || [],
      collectionData.value?.pre_air_images || [],
    ]),
});
</script>

<template>
  <div>
    <div class="h-20"></div>
    <div class="m-auto my-10 max-w-screen-lg px-5">
      <div v-if="pending" class="mt-20 text-center">
        <ProgressSpinner class="!h-20 !w-20" />
      </div>
      <div v-else-if="collectionData">
        <div>
          <CollectionMain :collection="collectionData" />
          <div class="flex flex-col gap-5 bg-surface-bg p-5 lg:p-10">
            <LatestEpisode
              v-if="collectionData.latest_episode"
              :episode="collectionData.latest_episode"
            />
            <SeasonsOrEpisodes :collection="collectionData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
